<template>
  <b-col sm="6" lg="4" v-if="draft && Object.keys(draft).length" @click="onEditDraft(draft.antraegeEntwuerfeId)" class="custom-button edit-box">
    <div class="button-box shadow" v-if="draft && Object.keys(draft).length">
      <div class="button-box-body">
        <small>{{ draft.lastUpdateDate | moment("DD.MM.YYYY HH:mm") }}</small>
        <strong>{{ draft.gesuchsartBezeichnung }}</strong>
        <p>{{ draft.gesuchCode }} {{ draft.antraegeEntwuerfeId }}</p>
      </div>
      <div class="button-legend">Zuletzt bearbeitet</div>
    </div>
  </b-col>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    created () {
      this.getLatestUpdatedDraft()
    },
    methods: {
      async getLatestUpdatedDraft () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('draft/GET_LATEST_UPDATED_DRAFT').then(res => {
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.hasUnknownError = true
          console.error(err)
        })
      },
      async onEditDraft (draftId) {
        try {
          this.hasUnknownError = false
          this.hasError = false
          const { errors } = await this.$store.dispatch('draft/GET_DRAFT_BY_ID', draftId)
          if (errors) {
            return errorHandler(this, errors)
          }
        } catch (err) {
          this.hasUnknownError = true
          console.error(err)
        }
      }
    },
    computed: {
      ...mapGetters({ draft: 'draft/LAST_UPDATED_DRAFT' })
    }
  }
</script>

<style lang="scss" >
  .edit-box{
    margin-top: 0;

    @include media-breakpoint-down(xs) {
      margin-top: 1rem;
    }
  }
</style>
